import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n";
import { CustomCursor } from "./components/CustomCursor";
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { ProductSpotlight } from "./components/ProductSpotlight";
import { EditorialMarquee } from "./components/EditorialMarquee";
import { AboutManifesto } from "./components/AboutManifesto";
import { ServicesGrid } from "./components/ServicesGrid";
import { ProductsCatalog } from "./components/ProductsCatalog";
import { WhyUsStats } from "./components/WhyUsStats";
import { GiantMarquee } from "./components/GiantMarquee";
import { SustainabilityBanner } from "./components/SustainabilityBanner";
import { ContactFooter } from "./components/ContactFooter";
import { QuoteModal } from "./components/QuoteModal";

function App() {
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white">
        <CustomCursor />
        <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-[2] bg-tech-grid" />
        <div aria-hidden="true" className="grain-overlay" />
        <Navbar onQuote={() => setQuoteOpen(true)} />
        <main>
          <HeroSection />
          <ProductSpotlight />
          <EditorialMarquee />
          <AboutManifesto />
          <ServicesGrid />
          <ProductsCatalog />
          <WhyUsStats />
          <GiantMarquee />
          <SustainabilityBanner />
          <ContactFooter />
        </main>
        <QuoteModal open={quoteOpen} onClose={() => setQuoteOpen(false)} />
        <Toaster richColors position="bottom-right" />
      </div>
    </LanguageProvider>
  );
}

export default App;
